<template>
  <label
    class="border cursor-pointer rounded-lg p-3 w-100 bg-exitos bg-exitos-0 bg-exitos-reveal-5"
  >
    <b-form-group class="mb-0">
      <b-form-checkbox v-model="modelValue">
        <h4 class="mb-1" v-text="title" />
        <div class="text-gray" v-text="description" />
      </b-form-checkbox>
    </b-form-group>
  </label>
</template>
<script setup>
import { useVModel } from "@vueuse/core";

const props = defineProps({
  value: {
    type: [Boolean, String, Number],
    default: false,
  },
  title: {
    type: String,
    default: "",
  },
  description: {
    type: String,
    default: "",
  },
});

const emits = defineEmits(["input"]);

const modelValue = useVModel(props, "value", emits, {
  eventName: "input",
});
</script>
